var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('p',[_c('a',{attrs:{"href":_vm.$Region.homeUrl,"title":("Go to the " + (_vm.$Region.app_name) + " Home Page")}},[_vm._v(_vm._s(_vm.$Region.app_name)+" Home")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }